import React from 'react'
import { l } from '@manychat/manyui'

const WASuccessfulVerificationNotification = () => {
  return <span>{l.translate('Your WhatsApp business account was successfully verified.')}</span>
}

export default WASuccessfulVerificationNotification
